import createComponent from '@carvana/merch-components/createComponent';

export const ReturnPolicyModalWrapper = createComponent('div', {
  className: 'bg-grey-1 p-32'
});

export const P = createComponent('p', {
  className: 'mb-20 text-[#757989] tl-body-s md:tl-body-m'
});
